import Translator from "utils/translator";

import("angular").then(angular => {
    var app = angular.module("tapAssetManager");

    app.controller("browserViewCtrl", [
        "$scope",
        "$filter",
        "assetPatcher",
        "assetStorage",
        "$compile",
        "$sce",
        "sharerTwitter",
        "angularGridInstance",
        "referralCodeService",
        function(
            $scope,
            $filter,
            assetPatcher,
            assetStorage,
            $compile,
            $sce,
            sharerTwitter,
            angularGridInstance,
            referralCodeService,
        ) {
            "use strict";

            $scope.typeDropdown = {
                items: [
                    {
                        title: Translator.trans("general.all"),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = false;
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.banner", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "image_banner" && asset.type !== "html5_banner";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.text_link", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "text_link";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.feed", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "feed";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.video", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "youtube_video" && asset.type !== "vimeo_video";
                            });
                        },
                    },
                    {
                        title: Translator.transChoice("asset.type.social_post", 2),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.typeHidden = asset.type !== "facebook_post" && asset.type !== "tweet";
                            });
                        },
                    },
                ],
                emptyContent:
                    '<span class="tapicon tapicon-filter"></span> Filter by type{{ (selected) ? ": " + selected : "" }}',
            };

            $scope.$on("assetsLoaded", function() {
                var sizes = {};

                angular.forEach($scope.assets, function(asset) {
                    if (asset.type_details.dimensions) {
                        sizes[
                            asset.type_details.dimensions.width + " x " + asset.type_details.dimensions.height
                        ] = null;
                    }

                    if (sizes.length > 0) $scope.sizeDropdown = $scope.sizeDropdown || {};
                });

                sizes = Object.keys(sizes);
                if (sizes.length === 0) return;

                var i = 0;
                $scope.sizeDropdown = {};
                $scope.sizeDropdown.items = [];
                angular.forEach(sizes.sort(), function(size) {
                    $scope.sizeDropdown.items.push({
                        title: size,
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                if (!asset.type_details.dimensions) {
                                    asset.sizeHidden = true;
                                    return;
                                }

                                var assetSize =
                                    asset.type_details.dimensions.width + " x " + asset.type_details.dimensions.height;
                                asset.sizeHidden = assetSize != item.data.title;
                            });
                        },
                    });

                    i++;
                    if (i !== 1) return;
                    $scope.sizeDropdown.emptyContent =
                        '<span class="tapicon tapicon-filter"></span> Filter by size{{ (selected) ? ": " + selected : "" }}';

                    $scope.sizeDropdown.items.unshift({
                        title: Translator.trans("general.all"),
                        action: function(item) {
                            angular.forEach($scope.assets, function(asset) {
                                asset.sizeHidden = false;
                            });
                        },
                    });
                });
            });

            var loaded = 0;
            var expectedBlocks;

            function getExpectedBlocks() {
                for (var i = $scope.assets.length - 1; i >= 0; i--) {
                    if (!$scope.facebookSharingDisabled && !$scope.twitterSharingDisabled) {
                        expectedBlocks = $scope.assets.length;
                        break;
                    }

                    if ($scope.facebookSharingDisabled && $scope.assets[i].type === "facebook_post") continue;
                    if ($scope.twitterSharingDisabled && $scope.assets[i].type === "tweet") continue;

                    expectedBlocks = expectedBlocks || 0;
                    expectedBlocks++;
                }
            }

            $scope.blockLoaded = function() {
                if (typeof expectedBlocks === "undefined") getExpectedBlocks();
                loaded++;
                if (loaded >= expectedBlocks) {
                    $scope.$broadcast("assetsLoaded");
                    angularGridInstance["asset-wall"].refresh();
                    $scope.initialLoadComplete = true;
                }
            };

            $scope.isHidden = function(asset) {
                return asset.labelHidden || asset.typeHidden || asset.sizeHidden;
            };

            $scope.isFiltered = function() {
                var hidden = $filter("filter")($scope.assets, function(asset) {
                    return $scope.isHidden(asset);
                });

                return hidden.length > 0;
            };

            $scope.visibleAssetCount = function() {
                var visible = $filter("filter")($scope.assets, function(asset) {
                    return !$scope.isHidden(asset);
                });

                return visible.length;
            };

            $scope.updateReferralCode = function(referralCode) {
                $scope.isLoading = true;
                return referralCodeService.update(referralCode, function() {
                    // Needs to be done inside callback
                    // otherwise this will be null in the storage
                    assetStorage.refresh(function() {
                        $scope.isLoading = false;
                    });
                });
            };
        },
    ]);
});
